<template>
  <div class="whatsapp-container">

    <!-- Sección del header -->
    <TwilioHeader
      @search-clicked="handleSearch"
      @menu-action="handleMenuAction"
    />

    <!-- Sección de filtros/buscador -->
    <TwilioFilters
      @search="handleSearch"
      @filter-change="handleFilterChange"
    />

    <!-- Sección principal de chats -->
    <TwilioChatPreview
      @chat-selected="handleChatSelect"
    />
  </div>
</template>

<script>
import TwilioChatPreview from '@/components/twilio/TwilioChatPreview.vue';
import TwilioFilters from '@/components/twilio/TwilioFilters.vue';
import TwilioHeader from '@/components/twilio/TwilioHeader.vue';

export default {
  name: 'WhatsappLayout',
  components: {
    // Futuros componentes:
    TwilioHeader,
    TwilioFilters,
    TwilioChatPreview,
  },
  data() {
    return {
      // Datos del layout
    }
  }
}
</script>

<style scoped>
/* Estilos para desarrollo con colores temporales */
.whatsapp-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f0f2f5;
  border: 2px solid red; /* Borde temporal */
}


.filters-section {
  height: 50px;
  background-color: #fff2cc; /* Color temporal para visualizar */
  border: 2px solid green; /* Borde temporal */
  padding: 8px 16px;
  display: flex;
  align-items: center;
}

.chats-section {
  flex: 1;
  overflow-y: auto;
  background-color: #ffe6e6; /* Color temporal para visualizar */
  border: 2px solid purple; /* Borde temporal */
  padding: 8px;
}

/* Estilos para texto temporal */
.temp-text {
  margin: 0;
  color: #666;
  font-size: 14px;
  text-align: center;
  width: 100%;
}

/* Estos estilos se pueden eliminar cuando se implementen los componentes reales */
</style>
